import axios, { AxiosResponse } from 'axios';
import { ProfileResponseData, UserTypeFromInternal, UserIdentifiers } from './types';

export const fetchData = async (url: string, params: object = {}, token: string | undefined, onSuccess: (data: any) => void, onError: (error: any) => void) => {
  try {
    const response: AxiosResponse = await axios.get(url, {
      params: params,
      headers: { Authorization: `Bearer ${token}` },
    });
    onSuccess(response.data);
  } catch (error) {
    onError(error);
  }
};

export const postData = async (url: string, bodyData: object = {}, token: string | undefined, onSuccess: (data: any) => void, onError: (error: any) => void) => {
  try {
    const response: AxiosResponse = await axios.post(url, bodyData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    onSuccess(response.data);
  } catch (error) {
    onError(error);
  }
};

export const replaceNullOrUndefinedWithEmptyString = (obj: any): any => {
  if (obj === null || obj === undefined) {
    return '';
  }
  if (typeof obj !== 'object') {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(replaceNullOrUndefinedWithEmptyString);
  }
  return Object.keys(obj).reduce((acc, key) => {
    acc[key] = replaceNullOrUndefinedWithEmptyString(obj[key]);
    return acc;
  }, {} as any);
};

export const patchData = async (url: string, token: string | undefined, params: any, onSuccess: (data: any) => void, onError: (error: any) => void) => {
  try {
    const response: AxiosResponse = await axios.patch(url, params, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    onSuccess(response.data);
  } catch (error) {
    onError(error);
  }
};

/* Used to get account id and user id for User managament (reset mfa, reset password, deactivate user...) */
export const getUserIdentifiers = (user: ProfileResponseData | UserTypeFromInternal, activeToken: any): UserIdentifiers => {
  const isInternal = activeToken?.internal;
  const accountId = isInternal ? (user as UserTypeFromInternal).accountId : String((user as ProfileResponseData).account.accountId);
  const userId = isInternal ? (user as UserTypeFromInternal).id : (user as ProfileResponseData).userId;

  return { accountId, userId };
};
